import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Form, Button, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Breadcrumb from '../../common/breadcrumb';
import PtTable from '../../../features/elements/table';
import PNotify from '../../../features/elements/p-notify';
import { getConfiguratorsWithFilter, deleteConfigurator } from '../../../api/configurator';
import { storageCsrf } from '../../../api/auth';

export default function ConfiguratorComercialList() {
  const [loading, setLoading] = useState(true);
  const [ajax, setAjax] = useState({
    data: [],
    total: 0,
  });

  // Filter Variables
  const [search, setSearch] = useState('');

  const [selectAll, setSelectAll] = useState(false);
  const [tableRef, setTableRef] = useState(null);
  const [selected, setSelected] = useState([]);
  const [bulk, setBulk] = useState('');

  // Columns
  const columns = [
    {
      Header: 'Contact',
      accessor: 'contact',
      sortable: true,
      Cell: (row) => (
        <>
          <Link
            to={`${process.env.PUBLIC_URL}/dashboard/contacts/${row.value.id}`}
            className='on-default edit-row mr-2'
          >
            {row.value.lastName.charAt(0).toUpperCase() + row.value.lastName.slice(1)} {row.value.firstName.charAt(0).toUpperCase() + row.value.firstName.slice(1)}
          </Link>
        </>
      ),
    },
    {
      Header: 'Category',
      accessor: 'projectCategory.name',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Amount',
      accessor: 'quizAnswer.amount',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Batteries Opt In',
      accessor: 'quizAnswer.batteriesOptIn',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Company Profile',
      accessor: 'quizAnswer.companyProfile',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Configuration',
      accessor: 'quizAnswer.configuration',
      sortable: true,
      Cell: (row) => (
        <>
          {JSON.parse(row.value) ?? ''}
        </>
      ),
    },
    {
      Header: 'Electrical System',
      accessor: 'quizAnswer.electricalSystem',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'kWh',
      accessor: 'quizAnswer.kWh',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Bridging Type',
      accessor: 'quizAnswer.bridgingType',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Mounting Surface',
      accessor: 'quizAnswer.mountingSurface',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Mounting Type',
      accessor: 'quizAnswer.mountingType',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Number Of Floors',
      accessor: 'quizAnswer.numberOfFloors',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Number Of People',
      accessor: 'quizAnswer.numberOfPeople',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Other Infos',
      accessor: 'quizAnswer.otherInfos',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Time Of Day',
      accessor: 'quizAnswer.timeOfDay',
      sortable: true,
      Cell: (row) => (
        <>
          {row.value ?? ''}
        </>
      ),
    },
    {
      Header: 'Actions',
      accessor: 'id',
      className: 'actions',
      headerClassName: 'justify-content-center',
      width: 100,
      Cell: (row) => (
        <>
          <a
            href='#del'
            className='on-default remove-row'
            onClick={(e) => deleteRow(e, row.value)}
          >
            <i className='far fa-trash-alt'></i>
          </a>
        </>
      ),
    },
  ];

  useEffect(() => {
    setSelected((selected) =>
      selected.map((item) => {
        return {
          ...item,
          selected: selectAll,
        };
      })
    );
    document.querySelector('body').classList.add('loaded');
  }, [selectAll]);

  function isSelected(key) {
    return selected.find((item) => item.id === key && item.selected);
  }

  function onSelectChange(e, value, row) {
    setSelected(
      selected.map((item) => {
        if (item.id === row.id) {
          return {
            ...item,
            selected: !item.selected,
          };
        }
        return item;
      })
    );
  }

  async function deleteRow(e, index) {
    e.preventDefault();
    if (window.confirm('Are you sure you want to delete this data?')) {
      let csrfToken;
      if (sessionStorage.getItem('csrfToken')) {
        csrfToken = sessionStorage.getItem('csrfToken');
      } else {
        csrfToken = await storageCsrf();
      }
      const deleteConfigurators = await deleteConfigurator(index, csrfToken);
      if (deleteConfigurators.status === 200) {
        setAjax({
          ...ajax,
          data: ajax.data.filter((item) => item.id !== index),
        });
        return toast(
          <PNotify
            title='Success'
            icon='fas fa-check'
            text={deleteConfigurators.data.message}
          />,
          {
            containerId: 'default',
            className: 'notification-success',
          }
        );
      } else {
        return toast(
          <PNotify
            title='Error'
            icon='fas fa-check'
            text={deleteConfigurators.data.message}
          />,
          {
            containerId: 'default',
            className: 'notification-danger',
          }
        );
      }
    }
  }

  async function bulkAction(e) {
    e.preventDefault();
    if (!bulk) {
      return toast(
        <PNotify
          title='Warning'
          icon='fas fa-exclamation'
          text='Please choose one of actions.'
        />,
        {
          containerId: 'default',
          className: 'notification-warning',
        }
      );
    }
    if (bulk === 'delete') {
      if (!selected.find((item) => item.selected)) {
        return toast(
          <PNotify
            title='Warning'
            icon='fas fa-exclamation'
            text='Choose at least one item.'
          />,
          {
            containerId: 'default',
            className: 'notification-warning',
          }
        );
      }

      let stringId = '';
      const bulkDeleteId = selected.filter((item) => item.selected);
      var bulkLength = bulkDeleteId.length;
      bulkDeleteId.forEach((item, index) => {
        if (index + 1 === bulkLength) {
          stringId += item.id;
        } else {
          stringId += item.id + '&';
        }
      });
      let csrfToken;
      if (sessionStorage.getItem('csrfToken')) {
        csrfToken = sessionStorage.getItem('csrfToken');
      } else {
        csrfToken = await storageCsrf();
      }
      const deleteUsers = await deleteConfigurator(stringId, csrfToken);
      if (deleteUsers.status === 200) {
        setAjax({
          ...ajax,
          data: ajax.data.filter((media) =>
            selected.find((item) => item.id === media.id && !item.selected)
          ),
        });
        return toast(
          <PNotify
            title='Success'
            icon='fas fa-check'
            text={deleteUsers.data.message}
          />,
          {
            containerId: 'default',
            className: 'notification-success',
          }
        );
      } else {
        return toast(
          <PNotify
            title='Error'
            icon='fas fa-check'
            text={deleteUsers.data.message}
          />,
          {
            containerId: 'default',
            className: 'notification-danger',
          }
        );
      }
    }
  }

  function searchConfigurators(e) {
    e.preventDefault();
    tableRef.current.wrappedInstance.filterColumn({ id: 'search' }, search);
  }

  function fetchData(state) {
    const listType = 'Comercial Sumar';
    let filtered = [...state.filtered];
    setLoading(true);
    getConfiguratorsWithFilter(
      state.page * state.pageSize,
      (state.page + 1) * state.pageSize,
      filtered,
      state.sorted,
      listType
    ).then((results) => {
      if(results?.data){
        setAjax({
          data: results.data,
          total:
            parseInt(results.total / state.pageSize) +
            !!(results.total % state.pageSize),
          totalRecords: results.total
        });
        setSelected(
          results.data.map((media) => {
            return {
              id: media.id,
              selected: false,
            };
          })
        );
        setSelectAll(false);
      }
      setLoading(false);
    });
  }

  return (
    <>
      <Breadcrumb
        current={'Configurator Comercial'}
        paths={[
          {
            name: 'Dashboard',
            url: '/dashboard',
          },
          {
            name: 'Configurator',
            url: '/dashboard/configurator',
          },
          {
            name: 'Comercial',
            url: '/dashboard/configurator/comercial',
          },
        ]}
      />

      <Row>
        <Col>
          <Form method='GET' action='#' onSubmit={searchConfigurators}>
            <Card className='card-modern'>
              <Card.Body>
                <div className='datatables-header-footer-wrapper'>
                  <div className='datatable-header'>
                    <Row className='align-items-lg-center mb-3'>
                      <Col
                        lg='auto'
                        className='mb-2 mb-lg-0 ml-xl-auto pl-xl-1'
                      ></Col>
                      <Col className='col-auto pl-lg-1'>
                        <div className='search search-style-1 mx-lg-auto w-auto'>
                          <InputGroup>
                            <Form.Control
                              type='text'
                              className='search-term'
                              placeholder='Search'
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <InputGroup.Append>
                              <Button variant='default' type='submit'>
                                <i className='bx bx-search'></i>
                              </Button>
                            </InputGroup.Append>
                          </InputGroup>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <PtTable
                    className='table table-ensys-simple -striped mb-0'
                    data={ajax.data}
                    loading={loading}
                    columns={columns}
                    pages={ajax.total}
                    pageSize={10}
                    manual
                    onFetchData={fetchData}
                    selectAll={selectAll}
                    toggleAll={() => setSelectAll(!selectAll)}
                    isSelected={(key) => isSelected(key)}
                    toggleSelection={onSelectChange}
                    onChangeRef={(ref) => setTableRef(ref)}
                    totalRecords={ajax.totalRecords}
                  />

                  <div className='datatable-footer'>
                    <Row className='align-items-center justify-content-between mt-3'>
                      <Col md='auto' className='mb-3 mb-lg-0'>
                        <div className='d-flex'>
                          <Form.Control
                            as='select'
                            className='select-style-1 bulk-action w-auto mr-3'
                            value={bulk}
                            onChange={(e) => setBulk(e.target.value)}
                            style={{ minWidth: '120px' }}
                          >
                            <option value=''>Bulk Actions</option>
                            <option value='delete'>Delete</option>
                          </Form.Control>
                          <Button
                            href='#bulk-action'
                            className='bulk-action-apply border font-weight-semibold text-color-dark text-3'
                            variant='light'
                            onClick={bulkAction}
                          >
                            Apply
                          </Button>
                        </div>
                      </Col>
                      <Col lg='auto' className='mb-3 mb-lg-0'>
                        <div className='pagination-wrapper d-flex justify-content-lg-end'></div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Col>
      </Row>
    </>
  );
}
